import { InsurancePlan } from '../../model/insurance/insurance-plan.model';

export class LoadInsurancePlans {
    static readonly type = '[Insurance] Load Insurance Plans';
}

export class SelectInsurancePlan {
    static readonly type = '[Insurance] Select Insurance Plan';
    constructor(public readonly insurancePlan: InsurancePlan) {}
}

export class ClearSelectedInsurancePlan {
    static readonly type = '[Insurance] Clear Selected Insurance Plan';
}

export class LoadInsuranceCustomer {
    static readonly type = '[Insurance] Load Insurance Customer';
    constructor(public readonly customerId: string) {}
}
